<template>
  <div
    :class="['weekday-picker form-element', hidden && 'd-none']"
    :data-test="dataTest"
  >
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <div
      v-for="(day, index) in weekdays"
      :key="day"
      class="weekday-picker__day d-inline-block"
      :data-test="day"
    >
      <input
        :id="getInputId(day)"
        v-model="localValue"
        type="checkbox"
        :name="day"
        :value="index"
        :disabled="disabled"
        @change="update"
      />
      <label
        :for="getInputId(day)"
        class="d-flex align-items-center"
      >
        {{ getWeekdayShortName(day) }}
      </label>
    </div>
  </div>
</template>

<script>
import _take from 'lodash/take'
import moment from 'moment'
import FormMixin from './FormMixin'
import FormLabel from './FormLabel'

export default {
  mixins: [ FormMixin ],
  components: { FormLabel },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ localValue: [] }),
  computed: {
    weekdays () {
      return moment.weekdays()
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.localValue = [ ...value ]
      },
    },
  },
  methods: {
    getInputId (day) {
      return `${this._uid}_${day}`
    },
    getWeekdayShortName (day) {
      return _take(day, 1).join('')
    },
    update () {
      this.$emit('input', [ ...this.localValue ].sort())
    },
  },
}
</script>

<style scoped>
.weekday-picker__day {
  position: relative;
}
.weekday-picker__day:not(:last-of-type) {
  margin-right: 6px;
}
.weekday-picker__day input {
  visibility: hidden;
  opacity: 0;
  position: absolute;
}
.weekday-picker__day label {
  font-size: 14px;
  background-color: var(--gray);
  color: var(--dark);
  border-radius: 100%;
  height: 32px;
  width: 32px;
  margin-top: 2px;
  justify-content: center;
  cursor: pointer;
}
.weekday-picker__day label:hover {
  opacity: 0.8;
}
.weekday-picker__day input:checked ~ label {
  background-color: var(--blue);
  color: white;
}
</style>
